import React, { useContext, useEffect, useState } from "react";
import { useMatch, useNavigate, useResolvedPath } from "react-router-dom";
import { COLOR_TEXT } from "../../../constants/colors";
import { IconCheveron } from "../../../icons/Icon";
import { StoreContext } from "../../../store/StoreContext";
import NavItemTemplate from "./NavItemTemplate";
import SubNavItem from "./SubNavItem";

const defaultColor = "#32373E";

const NavItem = ({ route, addCurrentRoute }) => {
  const resolved = useResolvedPath(route.path);
  const navigate = useNavigate();

  const { sidebarExpand } = useContext(StoreContext);

  const [expand, setExpand] = useState(false);

  const match = useMatch({ path: resolved.pathname, end: false});
  const active = Boolean(match);
  const color = active ? COLOR_TEXT : defaultColor;
  const isChildren = route?.children?.length > 0;

  useEffect(() => {
    if (!sidebarExpand) {
      setExpand(false);
      return;
    }

    if (active && isChildren) setExpand(true);
  }, [sidebarExpand]);

  const handleClick = () => {
    if (isChildren) {
      setExpand((val) => !val);
    } else {
      navigate(route.path);
      addCurrentRoute(route);
    }
  };

  return (
    <NavItemTemplate
      title={route.title}
      handleClick={handleClick}
      active={active}
      icon={route?.Icon && <route.Icon color={color} />}
      buttonExpand={
        isChildren && (
          <span className="expand-button">
            <IconCheveron color="#33383F" />
          </span>
        )
      }
    >
      {isChildren && (
        <div className={`menu-item-child ${expand ? "expand" : ""}`}>
          {route.children.map((item) => (
            <SubNavItem
              key={item.id}
              item={item}
              addCurrentRoute={addCurrentRoute}
            />
          ))}
        </div>
      )}
    </NavItemTemplate>
  );
};

export default NavItem;
